export default __webpack_public_path__ + "static/media/Markers_Green Marker.5d27d631.svg";